<template>
  <div ref="diklat">
    <v-card flat v-for="item in filterModul(items)" :key="item.id">
      <v-card-text>
        <v-row>
          <v-col cols="12" sm="12" md="6" lg="6" xl="6">
            <p class="body-1 my-0 py-0 gray--text text-caption ">
              Aktivitas
            </p>
            <p class="my-0 py-0 black--text">{{ pVal(item, "nama") }}</p>
          </v-col>
          <v-col cols="12" sm="12" md="3" lg="3" xl="3">
            <p class="body-1 my-0 py-0 gray--text text-caption ">
              Total Durasi Rekaman Main Room
            </p>
            <p :class="item.total_durasi_main_room > 0 ? 'blue--text font-weight-bold' : 'orange--text'">
              {{ item.total_durasi_main_room > 0 ? toTime(item.total_durasi_main_room) : "Belum unggah rekaman" }}
            </p>
            <p class="body-1 my-0 py-0 gray--text text-caption ">
              Total Durasi Rekaman Breakout Room
            </p>

            <p :class="item.total_durasi_breakout_room > 0 ? 'blue--text font-weight-bold' : 'orange--text'">
              {{ item.total_durasi_breakout_room > 0 ? toTime(item.total_durasi_breakout_room) : "Belum unggah rekaman" }}
            </p>
          </v-col>
          <v-col cols="12" sm="12" md="3" lg="2" xl="2">
            <m-button
              class="mt-2 white--text"
              isBlock
              small
              :textButton="item.rekaman.length > 0 ? 'Ubah Tautan' : 'Unggah Tautan'"
              :icon="item.rekaman.length > 0 ? 'mdi-pencil' : 'mdi-upload'"
              :large="false"
              dark
              action="enroll"
              @enroll="add(item, 'submodul')"
              :color="item.rekaman.length > 0 ? 'orange' : 'info'"
            ></m-button>
          </v-col>
        </v-row>
        <div></div>
      </v-card-text>
    </v-card>
    <RekamanDialog ref="rekamanDlg" />
  </div>
</template>

<script>
import RekamanDialog from "../../diklat/components/FormRekaman.vue";
import moment from "moment";
export default {
  components: {
    RekamanDialog
  },
  props: {
    items: {
      type: Array,
      default: () => []
    },
    tipe: {
      type: Number,
      default: 5
    },
    statuslink: {
      type: Number,
      default: 0
    },
    addData: {
      type: Boolean,
      default: false
    },
    kelas: {
      type: String,
      default: ""
    },
    link: {
      type: String,
      default: ""
    },
    moodle: {
      type: Object,
      default: null
    },
    notif: {
      type: Boolean,
      default: null
    }
  },

  data() {
    return {
      textSearch: null,
      selectedItems: [],
      page: null,
      cp: 1,
      current_page: 0,
      jump_page: 0,
      pagging: {},
      page_key: 0,
      totalPagination: [],
      more_menu: [
        {
          title: "Hapus Jadwal",
          icon: "mdi-delete",
          color: "error",
          click: (i, o) => this.hapusJadwalModul(o)
          // check: (i, o) => o.dosen.length != 0
        }
      ]
    };
  },
  computed: {
    headers() {
      const b = [{ text: "", align: "left", value: "", sortable: false }];
      return b;
    }
  },
  methods: {
    detail(item) {
      this.$refs.detailDlg.open(item);
    },
    add(item, tipe) {
      this.$refs.rekamanDlg.open(item, tipe).then(() => {
        this.$emit("load");
      });
    },
    toLMS(val) {
      var token = this.$store.getters["user/token"];
      window.open(val + "?access_token=" + token, "_blank");
    },
    toTime(value) {
      var seconds = moment.duration(value).seconds();
      var minutes = moment.duration(value).minutes();
      var hours = Math.trunc(moment.duration(value).asHours());
      return hours + ":" + minutes + ":" + seconds;
    },
    filterModul(value) {
      return value;
      // return value.filter(n => n.submodul.length > 0 || n.tanggal.length > 0);
    },
    filterSubmodul(value) {
      return value;
      // return value.filter(n => n.submodul.length > 0 || n.tanggal.length > 0);
    },
    filterTahap(value) {
      return value;
      // return value.filter(n => n.tanggal.length > 0);
    },
    totalDurasi(value) {
      var total = 0;
      value.forEach(rekaman => {
        total = total + rekaman.durasi;
      });
      return total;
    }
  },
  watch: {
    page(n) {
      if (n) {
        this.current_page = n.current_page;
        this.jump_page = n.current_page;
        this.page_key = Math.random();
        for (let i = 1; i <= n.last_page; i++) {
          this.totalPagination.push(i);
        }
      }
    },
    items() {
      this.selectedItems = [];
      var selected = this.selectedItems;

      setTimeout(function() {
        return (this.selectedItems = selected);
      }, 5);

      this.current_page = this.page ? this.page.current_page : 0;
    }
  }
};
</script>
